// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderChangeRequestHeaderComponent, {
    OrderChangeRequestHeaderPresentationProps,
} from "@store/Library/Components/OrderChangeRequest/OrderChangeRequestHeader";
import React, { FC } from "react";

export interface OrderChangeRequestHeaderWidgetProps extends WidgetProps {}

export interface OrderChangeRequestHeaderWidgetStyles {
    orderChangeRequestHeader?: OrderChangeRequestHeaderPresentationProps;
}

const orderChangeRequestHeaderWidgetStyles: OrderChangeRequestHeaderWidgetStyles = {};

const styles = orderChangeRequestHeaderWidgetStyles;

const OrderChangeRequestHeaderWidget: FC<WidgetProps> = ({ id }) => {
    return <OrderChangeRequestHeaderComponent {...styles.orderChangeRequestHeader} contentId={id} step={1} />;
};

const widgetModule: WidgetModule = {
    component: OrderChangeRequestHeaderWidget,
    definition: {
        group: constants.widgetGroup.orderChangeRequest,
        displayName: "Order Change Request Header",
        allowedContexts: [constants.pageType.orderChangeRequest],
    },
};

export default widgetModule;
